import { __assign, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import FakeButton from './FakeButton';
import s from './PlainButtonOrLink.scss';
var PlainButtonOrLink = function (_a) {
    var className = _a.className, isFakeButton = _a.isFakeButton, _b = _a.onClick, onClick = _b === void 0 ? function () { return null; } : _b, rest = __rest(_a, ["className", "isFakeButton", "onClick"]);
    var href = rest.href;
    var classNames = classnames(href ? s['link'] : s['button'], isFakeButton && s['fake-button'], className);
    var props = __assign({ className: classNames }, rest);
    return href ? (React.createElement(BiLink, __assign({ onClick: onClick }, props))) : !isFakeButton ? (React.createElement(BiButton, __assign({ onClick: onClick }, props))) : (
    // There are some instances where we need to render a button inside of a button. This is not correct HTML.
    // To solve this use-case, the following is a fake button using role="button" and the correct event handlers.
    React.createElement(FakeButton, __assign({ tabIndex: 0, onClick: onClick }, props)));
};
PlainButtonOrLink.displayName = 'PlainButtonOrLink';
export default PlainButtonOrLink;
//# sourceMappingURL=PlainButtonOrLink.js.map